import React, { useContext, useState, useEffect } from 'react';
import Page from '../../../components/Page';
import Panel from '../../../components/Panel';
import useAPI from '../../../hooks/useAPI';
import AuthContext from '../../../contexts/AuthContext';
import moment from 'moment/moment';
import Stat from '../../../components/SystemOverview/Stat';
import { ReactComponent as Bolt } from '../../../icons/system-overview/bolt.svg';
import { ReactComponent as Panels } from '../../../icons/system-overview/panels.svg';
import { ReactComponent as Batteries } from '../../../icons/system-overview/charging.svg';
import { ReactComponent as EVChargers } from '../../../icons/system-overview/ev_station.svg';
import { ReactComponent as Geothermal } from '../../../icons/system-overview/geothermal.svg';
import { ReactComponent as Lighting } from '../../../icons/system-overview/lighting.svg';
import './SystemOverview.scss';

export default function Dashboard (props) {
    const [loadingOverview, setLoadingOverview] = useState(true);
    const [overview, setOverview] = useState({});

    const api = useAPI();
    
    const {
        system
    } = useContext(AuthContext);

    const loadOverview = ()=>{
        api.json('GET', '/systems/' + system.id)
           .then(r=>r.json())
           .then(response=>{
                if(!response.data){
                    return;
                }

                setOverview(response.data.overview);
           })
           .catch(e=>{
                alert('Unable to load system information.');
           })
           .then(()=>setLoadingOverview(false));
    }

    useEffect(() => {
        loadOverview();
        // eslint-disable-next-line
    }, []);

    const installationText = overview.installed_at ? (
        <span>
            Installed <span style={{ fontWeight: 600 }}>{moment(overview.installed_at).format('MMM DD, YYYY')}</span> by <span style={{ fontWeight: 600 }}>{overview.installed_by}</span>
        </span>
    ) : '';

    return (
        <Page title="Dashboard" busy={loadingOverview}>
            <div className='row'>
                <div className='col-12'>
                    <Panel
                        title="Smart Home"
                        primary="true"
                        panelStyle={{
                            border: 'none'
                        }}
                        headerStyle={{
                            alignItems: 'center'
                        }}
                        headerMainStyle={{
                            minWidth: 500,

                        }}
                        description={
                            <>
                                <div>{installationText}</div>
                                {
                                    overview.stats ?
                                        <div style={{ padding: '30px 0' }}>
                                            <div className='row'>
                                                <div className='col-6'>
                                                    <Stat
                                                        icon={<Bolt />}
                                                        value={overview.stats.kw_ac + '/' + overview.stats.kw_dc}
                                                        metric="kW"
                                                        labels={[
                                                            "AC/DC Solar System",
                                                        ]}
                                                    />
                                                </div>
                                                <div className='col-6'>
                                                    <Stat
                                                        icon={<Panels />}
                                                        value={overview.stats.panels}
                                                        labels={[
                                                            "Panels"
                                                        ]}
                                                    />
                                                </div>
                                            </div>
                                            <div className='row'>
                                                <div className='col-6'>
                                                    <Stat
                                                        icon={<Batteries />}
                                                        value={overview.stats.batteries}
                                                        labels={[
                                                            "Batteries"
                                                        ]}
                                                    />
                                                </div>
                                                <div className='col-6'>
                                                    <Stat
                                                        icon={<EVChargers />}
                                                        value={overview.stats.ev_chargers}
                                                        labels={[
                                                            "EV Chargers"
                                                        ]}
                                                    />
                                                </div>
                                            </div>

                                            <div className='row'>
                                                <div className='col-6'>
                                                    <Stat
                                                        icon={<Geothermal />}
                                                        value={overview.geothermal}
                                                        labels={[
                                                            "Geothermal"
                                                        ]}
                                                    />
                                                </div>
                                                <div className='col-6'>
                                                    <Stat
                                                        icon={<Lighting />}
                                                        metric="Energy Efficiency"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        : null
                                }
                            </>
                        }
                        details={
                            <div style={{ maxWidth: 400 }}>
                                <img className='overview-image' alt='Home energy overview' src={'/assets/images/home-energy-overview.svg'} />
                            </div>
                        }
                    >
                    </Panel>
                </div>
            </div>
            {/*
                <div className='row'>
                    <div className='col-12'>
                        <ProductionReport
                            year={productionReportYear}
                        />
                    </div>
                </div>
             */}
        </Page>
    );
}